import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "icon is-medium" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, " ", -1)
const _hoisted_4 = { class: "icon is-medium clickAble" }
const _hoisted_5 = {
  key: 0,
  class: "panel-tabs"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 3,
  class: "panel-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_StatisticsTable = _resolveComponent("StatisticsTable")!
  const _component_StatisticsTableCategories = _resolveComponent("StatisticsTableCategories")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("p", {
      class: "panel-heading",
      style: {"display":"flex"},
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["stop"]))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: "chart-bar",
          size: "lg"
        })
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.t("keyfigures")), 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "chevron-up"
            }))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "chevron-down",
              size: "1x"
            }))
      ])
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
            return (_openBlock(), _createElementBlock("a", {
              key: cat,
              class: _normalizeClass({ 'is-active': _ctx.tab === cat }),
              onClick: ($event: any) => (_ctx.go(cat))
            }, _toDisplayString(_ctx.translateCategoryKey(_ctx.categoryLabel(cat))), 11, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOpen && _ctx.tab === '')
      ? (_openBlock(), _createBlock(_component_StatisticsTable, { key: 1 }))
      : (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_StatisticsTableCategories, {
            key: 2,
            categories: _ctx.tab
          }, null, 8, ["categories"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7))
  ]))
}